/**
 *  Legend script file
**/

import setDeviceWidthClass from '@/mixins/setDeviceWidthClass'
import { GETTERS } from '@/store'
import { mapGetters } from 'vuex'

export default {
  name: 'AenaLegend',
  mixins: [setDeviceWidthClass],
  components: {},
  props: {},
  data () {
    return {
      opened: false
    }
  },
  computed: {
    ...mapGetters({
      airport: GETTERS.GET_AIRPORT
    }),
    hasRoute () {
      return this.airport.has_graph
    }
  },
  methods: {
    toggle () {
      this.opened = !this.opened

      if (this.opened === true) {
        window.setTimeout(() => {
          this.$refs.legend.focus()
        }, 360)
      }
    }
  }
}
